import _ from 'lodash';

export enum BootstrapGridBreakpoints {
  xs = 0,
  sm = 576,
  md = 768,
  lg = 992,
  xl = 1200
}

class AppBootstrapService {
  public isXsUp = true;
  public isXsDown = false;
  public isXs = false;
  public isSmUp = false;
  public isSmDown = false;
  public isSm = false;
  public isMdUp = false;
  public isMdDown = false;
  public isMd = false;
  public isLgUp = false;
  public isLgDown = false;
  public isLg = false;
  public isXlUp = false;
  public isXlDown = false;
  public isXl = false;
  public width = 0;

  constructor() {
    window.addEventListener('resize', this.onResize.bind(this));
    this.evaluate();
  }

  private onResize() {
    this.evaluate();
  }

  private evaluate() {
    this.width = window.document.body.offsetWidth;
    this.isXsUp = true;
    this.isXsDown = this.isDown(BootstrapGridBreakpoints.xs);
    this.isXs = this.isXsUp && this.isXsDown;
    this.isSmUp = this.isUp(BootstrapGridBreakpoints.sm);
    this.isSmDown = this.isDown(BootstrapGridBreakpoints.sm);
    this.isSm = this.isSmUp && this.isSmDown;
    this.isMdUp = this.isUp(BootstrapGridBreakpoints.md);
    this.isMdDown = this.isDown(BootstrapGridBreakpoints.md);
    this.isMd = this.isMdUp && this.isMdDown;
    this.isLgUp = this.isUp(BootstrapGridBreakpoints.lg);
    this.isLgDown = this.isDown(BootstrapGridBreakpoints.lg);
    this.isLg = this.isLgUp && this.isLgDown;
    this.isXlUp = this.isUp(BootstrapGridBreakpoints.xl);
    this.isXlDown = this.isDown(BootstrapGridBreakpoints.xl);
    this.isXl = this.isXlUp && this.isXlDown;
  }

  public isUp(breakpoint: BootstrapGridBreakpoints) {
    return window.document.body.offsetWidth > breakpoint;
  }

  public isDown(breakpoint: BootstrapGridBreakpoints) {
    return window.document.body.offsetWidth <= this.getNextGridBreakpoint(breakpoint);
  }

  private getNextGridBreakpoint(breakpoint: BootstrapGridBreakpoints): number {
    let takeNext = false;
    return (
      _.find(BootstrapGridBreakpoints, b => {
        if (takeNext) {
          return true;
        }
        takeNext = b === breakpoint;
        return false;
      }) || 999999999
    );
  }
}

export const appBootstrapService = new AppBootstrapService();
